module.exports = __webpack_public_path__ + "static/img/Bachelor_010533.6048fdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010533.jpg
// module id = 183
// module chunks = 0